<template>
  <div class="main-main" @click="closeAbout">
    <div
      class="static-bg"
      :class="{ movingBg: audioPlaying }"
      :style="backgroundStyle"
    ></div>
    <div class="main-hero section-container">
      <!-- About modal is now handled globally in App.vue -->
      <div class="main-max-width max-width" v-show="!showAbout">
        <now-playing
          v-if="currentTrack"
          @audioPlaying="changeAudioPlayingState"
          :artist="currentTrack.artist"
          :title="currentTrack.title"
          :album="currentTrack.album"
          :year="currentTrack.year"
          :discogsUrl="currentTrack.discogs_url"
          :imageUrl="currentTrack.image_url"
          :favorited="currentTrack.favorited"
          @toggle-favorite="toggleFavoriteCurrentTrack"
          @open-signup="$emit('open-signup')"
        ></now-playing>
        <div v-else class="loading">Loading current track...</div>
        <div class="main-last-played">
          <div class="header-pasttrack">
            <span class="main-track">LAST PLAYED</span>
          </div>
          <last-played
            v-if="lastTracks && lastTracks.length"
            :lastTracks="lastTracks"
            @toggle-favorite="toggleFavoriteTrack"
            @open-signup="$emit('open-signup')"
          ></last-played>
          <div v-else class="loading">Loading history...</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api';
import { auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import NowPlaying from "./now-playing";
import LastPlayed from "./last-played";
import About from "./about";
export default {
  name: "Main",
  props: {
    showAbout: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    NowPlaying,
    LastPlayed,
    About,
  },

  data() {
    return {
      airtableApiKey: "pat099JSzRaXCiaZA.c1f52c67a3c8c15dacb4f6418558a57a883b39f266845c063f3d3c27eeabbe4f",
      currentTrack: null,
      lastTracks: [],
      backgrounds: [],
      isLandscape: true,
      audioPlaying: false,
      currentBackgroundUrl:
        "/playground_assets/nuance-background-test-4-1500h.jpg",
      user: null,
      screenWidth: window.innerWidth
    };
  },
  created() {
    onAuthStateChanged(auth, user => {
      this.user = user;
    });
  },
  methods: {
    async fetchNuanceTracks() {
      // Fetch track list
      const response = await api.get('/track_list');
      const current = response.data.shift().track;
      let lastTracks = response.data
        .map((e) => e.track)
        .filter(
          (track) =>
            track &&
            track.artist &&
            track.title &&
            !(
              current.artist &&
              current.title &&
              track.artist.trim().toLowerCase() === current.artist.trim().toLowerCase() &&
              track.title.trim().toLowerCase() === current.title.trim().toLowerCase()
            )
        );
      // Default: not favorited
      current.favorited = false;
      lastTracks = lastTracks.map(track => { track.favorited = false; return track; });
      // If user is logged in, fetch favorites and mark favorited
      if (this.user) {
        try {
          const favRes = await api.get(`/favorites/${this.user.uid}`);
          const favorites = favRes.data || [];
          // Helper to check if a track is in favorites
          function isFavorited(track) {
            return favorites.some(fav =>
              (fav.id && track.id && fav.id === track.id) ||
              (fav.artist && fav.title && track.artist && track.title &&
                fav.artist.trim().toLowerCase() === track.artist.trim().toLowerCase() &&
                fav.title.trim().toLowerCase() === track.title.trim().toLowerCase())
            );
          }
          current.favorited = isFavorited(current);
          lastTracks = lastTracks.map(track => {
            track.favorited = isFavorited(track);
            return track;
          });
        } catch (e) {}
      }
      this.currentTrack = current;
      this.lastTracks = lastTracks;
    },
    fetchBackgrounds() {
      api
        .get(
          "https://api.airtable.com/v0/appsaXjixp0CrLeHP/backgrounds?maxRecords=24&view=Grid%20view",
          { headers: { Authorization: `Bearer ${this.airtableApiKey}` } }
        )
        .then((response) => {
          this.backgrounds = response.data.records.map(
            (r) => r.fields.background_url
          );
        });
    },
    pickBackground() {
      this.currentBackgroundUrl = this.backgrounds[new Date().getHours()];
    },
    handleResize() {
      this.isLandscape = window.innerWidth > window.innerHeight;
      this.screenWidth = window.innerWidth;
    },
    closeAbout() {
      if (this.showAbout) {
        this.$emit("close-about", false);
      }
    },
    changeAudioPlayingState(isPlaying) {
      this.audioPlaying = isPlaying;
    },
    async toggleFavoriteCurrentTrack() {
      if (!this.user || !this.currentTrack) return;
      const userId = this.user.uid;
      const track = this.currentTrack;
      if (!track.favorited) {
        try {
          await api.post(`/favorites/${userId}`, track);
          this.$set(this.currentTrack, 'favorited', true);
          if (this.$eventBus) this.$eventBus.$emit('favorites-updated');
        } catch (e) {}
      } else {
        try {
          await api.delete(`/favorites/${userId}`, { data: { id: track.id, artist: track.artist, title: track.title } });
          this.$set(this.currentTrack, 'favorited', false);
          if (this.$eventBus) this.$eventBus.$emit('favorites-updated');
        } catch (e) {}
      }
    },
    async toggleFavoriteTrack(idx) {
      if (!this.user || !this.lastTracks[idx]) return;
      const userId = this.user.uid;
      const track = this.lastTracks[idx];
      if (!track.favorited) {
        try {
          await api.post(`/favorites/${userId}`, track);
          this.$set(this.lastTracks[idx], 'favorited', true);
          if (this.$eventBus) this.$eventBus.$emit('favorites-updated');
        } catch (e) {}
      } else {
        try {
          await api.delete(`/favorites/${userId}`, { data: { id: track.id, artist: track.artist, title: track.title } });
          this.$set(this.lastTracks[idx], 'favorited', false);
          if (this.$eventBus) this.$eventBus.$emit('favorites-updated');
        } catch (e) {}
      }
    },
  },
  computed: {
    backgroundStyle() {
      const width = this.screenWidth;
      // Use local vertical background for mobile/tablet breakpoints
      if (width <= 991) {
        return `background-image: url('/playground_assets/nuance-background-vertical-1500w.jpg'),linear-gradient(90deg, rgb(189, 195, 199) 0.00%,rgb(0, 0, 0) 100.00%)`;
      }
      const currentHour = new Date().getHours();
      const bg_index = currentHour < 10 ? "0" + currentHour : currentHour;
      const orientation = this.isLandscape ? "horizontal" : "vertical";
      const url = `https://nuance-radio-media.s3.eu-central-1.amazonaws.com/img/background/${orientation}/nuance-background-${bg_index}h.jpg`;
      return `background-image: url("${url}"),url("/playground_assets/default_background.jpeg"),linear-gradient(90deg, rgb(189, 195, 199) 0.00%,rgb(0, 0, 0) 100.00%)`;
    },
  },
  beforeMount() {
    this.fetchBackgrounds();
  },
  mounted() {
    this.handleResize();
    this.fetchNuanceTracks();
    setInterval(this.fetchNuanceTracks, 5000);
    setInterval(this.pickBackground, 1000);
    window.addEventListener("orientationchange", this.handleResize);
    window.addEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
.about-box {
  max-width: 100vh;
  margin: 10px;
  height: 100%;
}

.main-main {
  width: 100%;
  /* display: flex; */
  flex: 1;
  position: relative;
  border-color: #000000;
  border-width: 0.5rem;
}

.static-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  background-size: cover;
  z-index: -1;
}

@media (min-width: 991px) {
  .main-main {
    overflow: hidden;
  }

  .movingBg {
    animation: psyche 55s infinite;
    animation-direction: alternate;
    animation-timing-function: linear;
  }

  @keyframes zoomInOut {
    0% {
      transform: scale(1); /* Original size */
    }
    50% {
      transform: scale(1.2); /* Zoom in slightly */
    }
    100% {
      transform: scale(1); /* Back to original size */
    }
  }

  .movingBg {
    animation: zoomInOut 30s infinite; /* Slow zoom in/out over 30 seconds */
    animation-timing-function: ease-in-out; /* Smooth easing */
  }
}

.main-hero {
  width: 100%;
  height: 100%;
  position: relative;
  align-items: center;
  padding-top: 0px;
  padding-bottom: 0px;
  justify-content: center;
  background-color: transparent;
}
.section-container {
  width: 100%;
  display: flex;
  overflow: hidden;
  align-items: center;
  flex-direction: column;
}
.main-max-width {
  width: 55%;
  align-items: center;
  flex-direction: row;
  /* justify-content: center; */
}
.main-last-played {
  width: 100%;
  position: relative;
}
.header-pasttrack {
  top: 4px;
  left: 0px;
  position: absolute;
  transform: translateY(-100%);
  flex-direction: column;
  justify-content: flex-start;
}
.main-track {
  color: #ff7676;
  font-size: var(--played) !important;
  transform: translateY(0.2%);
  font-style: normal;
  font-family: Syne;
  line-height: 1;
  padding: 2px 4px 2px 4px;
  background-color: #ffffff;
}
.main-event {
  display: none;
  align-items: center;
}
.main-text {
  color: #000000;
  font-style: normal;
  font-family: Syne;
  font-weight: 400;
  text-decoration: underline none;
}
.main-text2 {
  font-weight: 700;
}
.main-socials {
  display: none;
}
.main-root-class-name {
  height: 100%;
}
@media (max-width: 1600px) {
  .main-max-width {
    width: 65%;
  }
  .main-root-class-name {
    height: 100%;
  }
}
@media (max-width: 1200px) {
  .main-main {
    border-width: 0.8vw;
  }
  .main-hero {
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .main-max-width {
    width: 70%;
  }
  .main-last-played {
    width: 100%;
  }
  .main-track {
    transform: translateY(20%);
    line-height: 1;
    padding: 0.2vw 6px;
  }
  .main-text {
    font-size: 0.9vw;
  }
  .main-root-class-name {
    height: 100%;
  }
}

@media (max-width: 991px) {
  .main-main {
    border-width: 0.8vw;
    position: static !important;
  }
  .main-hero {
    padding-top: 40px;
    padding-left: 100;
    padding-right: 100;
    justify-content: unset;
  }
  .main-max-width {
    width: 90%;
    height: auto;
    flex-direction: column;
  }
  .main-last-played {
    margin-top: 60px;
    padding-bottom: 15vw;
  }
  .static-bg {
    background-size: cover !important;
    background-position: center center !important;
    background-repeat: no-repeat !important;
    min-height: 100vh;
    height: 100vh;
    top: 0;
    bottom: 0;
  }
}
@media (max-width: 767px) {
  .static-bg {
    position: fixed !important;
    width: 100vw !important;
    height: 100vh !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    background-attachment: fixed !important;
    background-size: cover !important;
    background-position: center center !important;
    background-repeat: no-repeat !important;
    z-index: -1 !important;
  }
  .main-main {
    position: relative;
    z-index: 1;
    background: transparent;
  }
  .main-hero {
    width: 100%;
    align-self: flex-start;
    padding: 40px 0px 0px 0px;
  }

  .main-max-width {
    widows: 100%;
  }
  .main-event {
    display: flex;
    background: white;
    padding-top: 1vw;
    padding-left: 2vw;
    margin-bottom: 3vw;
    padding-right: 2vw;
    padding-bottom: 1vw;
  }
  .main-text {
    font-size: 3vw;
  }
  .main-socials {
    display: flex;
    background: white;
    padding-top: 1vw;
    padding-left: 1vw;
    margin-bottom: 10vw;
    padding-right: 1vw;
    padding-bottom: 1vw;
  }
  .main-icon {
    width: 4vw;
    margin-right: 1.3vw;
  }
  .main-icon2 {
    width: 3.5vw;
    margin-right: 1.5vw;
  }
  .main-icon4 {
    width: 4vw;
  }
  .header-pasttrack {
    top: 4px;
    left: 0px;
    position: absolute;
    justify-content: center;
  }
}
@media (max-width: 479px) {
  .main-hero {
    padding-left: 0;
    padding-right: 0px;
  }
  .main-track {
    transform: translateY(1, 1);
    padding: 2px 4px 2px 4px;
  }
  .main-socials {
    background: white;
  }
}
.loading {
  color: #888;
  text-align: center;
  margin: 2em 0;
  font-size: 1.2em;
}
</style>
